import React from "react";
import Chart from "react-apexcharts";

export default function InstitutionSingle({ data }) {
  return (
    <Chart
      options={data.options}
      series={data.series}
      type="bar"
      //height={"1400px"}
    />
  );
}
